import React from "react";
import { FORM_ERROR } from "final-form";
import { useIntl } from "react-intl";

import useTrashablePromises from "hooks/useTrashablePromises";
import translateError from "utils/translateError";
import useGlobalContext from "hooks/globalData";
import {
  SkuFormat,
  ISkuFormatSaveRequest,
  SkuFormatSaveRequest,
  SaveResponse,
} from "services/KnowfullyAdminClient";

import SkuFormatForm from "./SkuFormatForm";

type SkuFormatUpdateFormProps = {
  skuFormat: SkuFormat;
  onSkuFormatUpdated: (id: string) => void;
  onCancel: () => void;
};

const SkuFormatUpdateForm = ({
  skuFormat,
  onSkuFormatUpdated,
  onCancel,
}: SkuFormatUpdateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const onSubmit = (values: ISkuFormatSaveRequest) => {
    return registerPromise(
      skuService.saveSkuFormat(
        new SkuFormatSaveRequest({ id: skuFormat.id, ...values })
      )
    )
      .then(({ id }: SaveResponse) => {
        onSkuFormatUpdated(id!);
      })
      .catch((err: any) => {
        console.log(err);
        return { [FORM_ERROR]: translateError(err, t) };
      });
  };

  return (
    <SkuFormatForm
      skuFormat={skuFormat}
      onSubmit={onSubmit}
      submitLabel={t({ id: "skuFormatUpdateButton" })}
      onCancel={onCancel}
    />
  );
};

export default SkuFormatUpdateForm;
